import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Observable, of, switchMap, takeUntil } from 'rxjs';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
@Injectable({
    providedIn: 'root',
})
export class UserRoleGuard implements CanActivate, CanActivateChild {
    constructor(
        private AuthServices: AuthService,
        private toastr: ToastrService
    ) { }
    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        let user: any = JSON.parse(localStorage.getItem('user'));
        let currentRoute = childRoute.data.tittle;
        if (currentRoute) {
            let userData = {
                _id: user._id,
                name: currentRoute,
            };

            return this._check(userData);
        } else {
            return of(true);
        }
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
        let user: any = JSON.parse(localStorage.getItem('user'));

        let currentRoute = route.routeConfig.path;

        let userData = {
            _id: user._id,
            name: currentRoute,
        };
        return this._check(userData);
    }

    /**
     * Check the permission status
     *
     * @param userData
     * @private
     */
    private _check(userData: any): Observable<boolean> {
        // Check the authentication status
        return this.AuthServices.getPermission(userData).pipe(
            switchMap((res: any) => {
                if (res.value) {
                    return of(true);
                } else {
                    this.toastr.error(
                        'You did not have permission to access this section'
                    );
                    return of(false);
                }
            })
        );
    }
}
